<template>
  <router-view/>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  /* 隐藏页面右侧的垂直滚动条 */
  /* overflow-y: hidden; 禁止垂直方向的滚动条显示 */
}

#app {
  height: 100%;
  width: 100%;
}
</style> 